import {Injectable} from '@angular/core';
import {ExcCoreModule} from 'exc-core-v2';
import {ExcSecurityService} from 'exc-security-v2';

@Injectable({providedIn: 'root'})
export class UserSettingsService {

  private excRestService = ExcCoreModule.Services().ExcRest;

  textvorlagen: any[] = [];
  stempel: any[] = [];

  loadAll(): void {
    this.loadTextvorlagen();
    this.loadStempel();
  }

  loadTextvorlagen(): void {
    this.excRestService
      .sget(this.excRestService.computeUrl('UserTextbausteineR_List', {}),
        ExcCoreModule.Guid.NewGuid(), {})
      .subscribe((ret: any) => {
        if (ret.success && ret.data?.Textbaustein) {
          this.textvorlagen = ret.data.Textbaustein;
        }
      });
  }


  loadStempel(): void {
    this.excRestService
      .sget(this.excRestService.computeUrl('UserStempelR_List', null),
        ExcCoreModule.Guid.NewGuid(), {})
      .subscribe((ret: any) => {
        if (ret.success && ret.data?.UserStempel) {
          this.stempel = ret.data.UserStempel;
        }
      });
  }
}
